export const CONTACT_PHONE = '08007701318'
export const OMBUDSMAN_PHONE = '08007403994'
